module.exports = __webpack_public_path__ + "img/add.9bffe4c8.svg";